import { createFileRoute, redirect } from "@tanstack/react-router";
import HrdCasesDataGrid from "@components/hrd/cases/HrdCasesDataGrid.tsx";
import AppCard from "@components/AppCard.tsx";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN, ROLE_USER } from "@/constants";
import { getHasHrdAccess } from "@/auth/hasHrdAccess.tsx";

export const Route = createFileRoute("/_dashboard/hrd/cas/")({
  beforeLoad: (args) => {
    const { context } = args;
    requireRole([ROLE_ADMIN, ROLE_USER])(args);
    const hasHrdAccess = getHasHrdAccess(
      context.session!.user!.hrdAccessStatus
    );

    // Check HRD access for non-admins only
    if (!context.session?.user?.isAdmin && !hasHrdAccess) {
      throw redirect({
        to: "/unauthorized",
        search: {
          redirect: location.href,
        },
      });
    }

    return { session: context.session! };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { session } = Route.useRouteContext();

  return (
    <AppCard title={"HRD Collect - Cas"}>
      <HrdCasesDataGrid />
    </AppCard>
  );
}
